import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export const validations = () => ({
    formData: {
        message: { required, min_length: minLength(2), max_length: maxLength(512) },
    }
});